import type { GetInvoicePdfResponse } from '@vy/api-definition';
import { GetInvoicePdfResponseSchema } from '@vy/api-definition';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function invoicePdfQuery(invoiceId: string) {
  const api = getPrivateApi();
  const response = await api.getInvoicePdf({ invoiceId });

  return GetInvoicePdfResponseSchema.parse(response);
}

export function useInvoicePdf(invoiceId: string, options?: CustomUseQueryOptions<GetInvoicePdfResponse>) {
  return useQuery({
    queryKey: queryKeys.invoicePdf(invoiceId),
    queryFn: () => invoicePdfQuery(invoiceId),
    ...options,
  });
}

export async function prefetchInvoicePdf(invoiceId: string, queryClient: QueryClient) {
  await queryClient.prefetchQuery(queryKeys.invoicePdf(invoiceId), () => invoicePdfQuery(invoiceId));
}

export function useInvoicesPdfs(invoiceIds: string[]) {
  return useQuery({
    queryKey: queryKeys.invoicePdf(...invoiceIds),
    queryFn: async () => {
      const api = getPrivateApi();
      const requests = invoiceIds.map((invoiceId) => {
        return api.getInvoicePdf({ invoiceId });
      });
      const responses = await Promise.all(requests);

      return responses.map((response) => GetInvoicePdfResponseSchema.parse(response));
    },
  });
}
